import script from "./login-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

import "./login-ranking-chart.vue?vue&type=style&index=0&id=0f8bbc44&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f8bbc44"]])

export default __exports__